import Vue from 'vue'

export default {
  logged: function (state, user) {
    state.isLogged = !!user.token
    state.fullname = user.fullname
    state.username = user.username
    state.token = user.token

    sessionStorage.setItem('isLogged', true)
    sessionStorage.setItem('fullname', user.fullname)
    sessionStorage.setItem('username', user.username)
    sessionStorage.setItem('token', user.token)
  },
  logout: function (state) {
    // Reset default state.
    state.isLogged = false
    state.token = null
    state.fullname = ''
    state.username = ''

    // Remove common request auth token.
    delete Vue.prototype.$http.defaults.headers.common['Token-Auth']

    // Cleanuo session data.
    sessionStorage.removeItem('isLogged')
    sessionStorage.removeItem('fullname')
    sessionStorage.removeItem('username')
    sessionStorage.removeItem('token')

    // Cleanup local data.
    localStorage.removeItem('multipliers')
    localStorage.removeItem('adspaces')
    localStorage.removeItem('affiliates')
    localStorage.removeItem('apikeys')

    location.href = '/login'
  }
}
